<template>
  <div id="thank-root" class="text-center quest_topic">
    <div>
      <v-card >
        <a :href="pictureLink">
          <!-- <img v-bind:src="picture" max-width="500" /> -->
          <!-- 修正破圖問題 -->
          <img v-bind:src="picture" style="max-width:100%;" />
        </a>
        <div class=" pl-3 pr-3 text-start">{{ $store.state.questM.qusetThank }}</div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    pictureLink() {
      let questTransUrl = this.$store.state.questM.questTransUrl
      let haveTransUrl = questTransUrl != null && questTransUrl.length > 0
      if (haveTransUrl) {
        return questTransUrl
      } else {
        return '#'
      }
    },
    picture() {
      let storePic = this.$store.state.questM.qusetThankPic
      if (storePic !== null && storePic.length > 0) {
        return this.$store.state.server + storePic
      } else {
        return this.$store.state.server + 'img/0/default_thx.jpg'
      }
    }
  },
  methods: {
    // 沒有作用
    close() {
      window.close()
    }
  }
}
</script>
<style lang="scss" scoped>
#thank-root {
  width: 100%;  
  // 破圖問題
  // height: 100%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
